<ngx-smart-modal #myModal1 identifier="myModal1">
  <h2 class="modalError">Please login and subscribe to access this content.</h2>
  <button class="modalErrorButton" (click)="myModal1.close()" routerLink="/login">Login Now</button>
</ngx-smart-modal>
 <!-- <ngx-smart-modal #myModal2 identifier="myModal2">
   <h2 class="modalError">Oh No, something went wrong, please refresh the page.</h2>
   <button class="modalErrorButton" (click)="myModal2.close(); refresh()" >Refresh Now</button>
 </ngx-smart-modal> -->
<app-header></app-header>
<div id="wrapper">
    <app-sidebar></app-sidebar>
    <div class="single-channel-page" id="content-wrapper">
        <div class="single-channel-image">
            <img class="img-fluid" alt="" src={{tag?.profileUrl}}>
            <div class="channel-profile">
                <img class="channel-profile-img" alt="" src={{tag?.profileUrl}}>
            </div>
        </div>
        <div class="single-channel-nav">
            <nav class="navbar navbar-expand-lg navbar-light">
                <p class="channel-brand" [class.active]="viewMode == 'tab1'" rel="tab1" (click)="viewMode ='tab1'" >{{tag?.text}}
                    <span title="" data-placement="top" data-toggle="tooltip" data-original-title="Verified">
                        <i class="fas fa-check-circle text-success"></i>
                    </span>
                  </p>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">

                    <ul class="navbar-nav mr-auto">
                            <li class="nav-item">
                                    <a class="nav-link" [class.active]="viewMode == 'tab1'" rel="tab1" (click)="viewMode ='tab1'">Category Home</a>
                                </li>
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="viewMode == 'tab2'" rel="tab2" (click)="viewMode ='tab2'">All Videos</a>
                        </li>
                        
                      
              
                    </ul>
                    <form class="form-inline my-2 my-lg-0">
                        <input class="form-control form-control-sm mr-sm-1" type="search" placeholder="Search" aria-label="Search">
                        <button class="btn btn-outline-success btn-sm my-2 my-sm-0" type="submit">
                            <i class="fas fa-search"></i>
                        </button> &nbsp;&nbsp;&nbsp;
                        <button class="btn btn-outline-danger btn-sm" type="button">Subscribe
                            <strong>1.4M</strong>
                        </button>
                    </form>
                </div>
            </nav>
        </div>
        <div class="container-fluid">
            <div class="video-block section-padding">
                <div class="row">
                    <div class="col-md-12">
                        <div class="main-title">
                      
                        </div>
                    </div>
                   
                        <div class="tab-slider" [ngSwitch]="viewMode">
                                <div id="tab1" class="tab-slider--body" *ngSwitchCase="'tab1'">
                                                <div class="video-block section-padding">
                                                   <div class="row">
                                                      <div class="col-md-12">
                                                           <div class="main-title">
                                                             <h6>Latest Videos</h6>
                                                           </div>
                                                          
                                                           </div>
                                                           <div *ngFor="let video of contents | slice:0:4; let i=index;" class="col-xl-3 col-sm-6 mb-3">
                                                                <div class="video-card">
                                                                  <div class="video-card-image" [class.educationImages]="isHeadStart">
                                                                    <a class="play-icon" routerLink="/play/{{video.currentContentView}}">
                                                                      <i class="fas fa-play-circle"></i>
                                                                    </a>
                                                                    <a routerLink="/play/{{contents.currentContentView}}">
                                                                      <img *ngIf="!isHeadStart" class="img-fluid" src="{{video.contentImageUrl}}" alt=""><img *ngIf="isHeadStart" class="img-fluid" src="{{video.contentImagePortraitUrl}}" alt="">
                                                                    </a>
                                                                  
                                                                  </div>
                                                                  <div class="video-card-body">
                                                                    <div class="video-title">
                                                                      <a routerLink="/play/{{video.currentContentView}}">{{video.title}}</a>
                                                                      
                                                                    </div>
                                                                    <div class="video-page text-success">
                                                                      <a title="" data-placement="top" data-toggle="tooltip" routerLink="/play/{{video.currentContentView}}" data-original-title="Verified">
                                                                         </a>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                             </div>
                                                            <div class="row">
                                                                    <span class="centercontent"><button [class.active]="viewMode == 'tab2'" rel="tab2" (click)="viewMode ='tab2'" _ngcontent-c8="" class="btn btn-outline-danger btn-lg" type="button">View All <i _ngcontent-c3="" class="fas fa-fw fa-sign-out-alt"></i></button></span>
                                                            </div>
                                                            </div></div> <div id="tab2" class="tab-slider--body" *ngSwitchCase="'tab2'">
                                    <div class="video-block section-padding">
                                            <div class="row">
                                               <div class="col-md-12">
                                                    <div class="main-title">
                                                      <h6>All Videos</h6>
                                                    </div>
                                                   
                                                    </div>
                                                    <div *ngFor="let video of contents; let i=index;" class="col-xl-3 col-sm-6 mb-3">
                                                            <div class="video-card">
                                                              <div class="video-card-image" [class.educationImages]="isHeadStart">
                                                                <a class="play-icon" routerLink="/play/{{video.currentContentView}}">
                                                                  <i class="fas fa-play-circle"></i>
                                                                </a>
                                                                <a routerLink="/play/{{contents.currentContentView}}">
                                                                  <img *ngIf="!isHeadStart" class="img-fluid" src="{{video.contentImageUrl}}" alt=""><img *ngIf="isHeadStart" class="img-fluid" src="{{video.contentImagePortraitUrl}}" alt="">
                                                                </a>
                                                              
                                                              </div>
                                                              <div class="video-card-body">
                                                                <div class="video-title">
                                                                  <a routerLink="/play/{{contents.currentContentView}}">{{video.title}}</a>
                                                                  
                                                                </div>
                                                                <div class="video-page text-success">
                                                                  <a title="" data-placement="top" data-toggle="tooltip" routerLink="/play/{{video.currentContentView}}" data-original-title="Verified">
                                                                      </a>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                      </div></div>
                            </div>
                            <div id="tab3" class="tab-slider--body" *ngSwitchCase="'tab3'">
                                    <div class="video-block section-padding">
                                            <div class="row">
                                               <div class="col-md-12">
                                                    <div class="main-title">
                                                      <h3>All Categories</h3>
                                                    </div>
                                                   
                                                    </div>
                                                    <div *ngFor="let category of tag; let i=index;" class="col-xl-3 col-sm-6 mb-3">
                                                         <div class="channels-card">
                                                            <div class="channels-card-image video-box">
                                                               <a routerLink="#"><img class="img-fluid" src={{tag.imageUrl}} alt=""></a>
                                                               <div class="channels-card-image-btn"><button type="button" class="btn btn-outline-danger btn-sm">Explore Playlist</button></div>
                                                            </div>
                                                            <div class="channels-card-body">
                                                               <div class="channels-title">
                                                                  <a routerLink="#">{{playlist.name}}</a>
                                                               </div>
                                                            </div>
                                                         </div>
                                                      </div>
                                                      </div></div> 
                            </div>

                      
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
            <!-- Sticky Footer -->
        </div>
    </div>
</div>
<app-footer></app-footer>